import {
  Component,
  OnInit,
  ChangeDetectorRef,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { DataService } from 'src/app/services/data.service';
import { Constants } from 'src/app/core/constants';
import { FileToBeUploaded } from 'src/app/models/internal/file-tobe-uploaded';
import { FormFileToBeUploaded } from '../../models/internal/formfile-tobe-uploaded';
import { InfoButtonDocument } from '../../models/infobutton-document';

class FileUploadSnippet {
  pending: boolean = false;
  status: string = 'init';

  constructor(public src: string, public file: File) {}
}


@Component({
  selector: 'app-infobutton-documentupload',
  templateUrl: './infobutton-documentupload.component.html',
  styleUrls: ['./infobutton-documentupload.component.scss']
})
export class InfobuttonDocumentuploadComponent implements OnInit {
  documentuploadForm = this.fb.group({
    file: [null, Validators.required],
});
@Input() infoButtonId: number;
@Output() private infoButtonDocumentUploaded: EventEmitter<FileToBeUploaded> = new EventEmitter<
FileToBeUploaded
>();
fileStream = '';

selectedFile: FileUploadSnippet;
    // selectedFile: File; //[] = [];
    constructor(
        private fb: FormBuilder,
        private toastService: ToastService,
        private cd: ChangeDetectorRef,
        private dataService: DataService
    ) {}

    ngOnInit() {}

    onFileChanged(documentInput: any) {
        const file: File = documentInput.files[0];
        const reader = new FileReader();

        reader.addEventListener('load', (event: any) => {
            this.selectedFile = new FileUploadSnippet(event.target.result, file);
            this.fileStream = event.target.result;
            this.selectedFile.pending = true;
            const documentToBeUploaded: FileToBeUploaded = {
                File: this.fileStream,
                Type: 1,
                FileName: file.name,
                Url: this.fileStream
            }
            this.infoButtonDocumentUploaded.emit(documentToBeUploaded);
        });
        reader.readAsDataURL(file);
    }
}
